module.exports = __webpack_public_path__ + "img/status-promotion.a6765375.png";